import { render } from "./index.vue?vue&type=template&id=683ae573&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=683ae573&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-683ae573"

export default script